import React, { Component } from 'react'
import { Map, List } from 'immutable'

import OfferResponseFilters from './OfferResponseFilters'
import OfferGroupsFilterPanels from './OfferGroupsFilterPanels'
import AccommodationOfferGroup from './AccommodationOfferGroup'
import scrollToComponent from 'react-scroll-to-component';

class AccommodationOffersResponse extends Component {
  constructor(){
    super()
    this.state = {
      // Per-response filters. Externalised, so that we can
      // display them in a separate, docked filter panel
      filterByOfferGroup: Map()
    }
  }

  updateFilter = (index, filterFn) => {
    scrollToComponent(this.offerResponseDiv, { offset: 0, align: 'top', duration: 500, ease:'inQuad'});
      this.setState({
          filterByOfferGroup: this.state.filterByOfferGroup.set(index, filterFn)
      })
  }

  render()
  {
    const {accommodationGetOffersResponse = Map(), selectOffer, unselectOffer, selectionByOfferGroup, referenceData, startBooking, toggleFilterPanel, filterPanelOpen } = this.props
    const { filterByOfferGroup } = this.state
    const offerGroups = accommodationGetOffersResponse.get('offerGroup', List())
    return <div className="offer-response" ref={(div)=>this.offerResponseDiv = div}>
      <OfferResponseFilters onFilterToggle={toggleFilterPanel} view="get-a-room"/>
      <div className="container result-list hotels-result-list">
        <OfferGroupsFilterPanels offerGroups={offerGroups} visible={filterPanelOpen} updateFilter={this.updateFilter.bind(this)}  view="get-a-room"/>
        <div className="view offer-groups active">
            {offerGroups.map((og = Map(), i) =>
                <AccommodationOfferGroup
                    offerGroup={og}
                    accommodationSummaryById={referenceData.accommodationSummaryById}
                    filterFn={filterByOfferGroup.get(i)}
                    groupNo={i}
                    showHeading={offerGroups.size > 1}
                    passengerCount={accommodationGetOffersResponse.getIn(['participants', 'participant'], List()).size}
                    selectOffer={(u)=>selectOffer(i,u)}
                    unselectOffer={(u)=>unselectOffer(i,u)}
                    selectedOffers={selectionByOfferGroup.get(i)}
                    key={i} />
            )}
            {/* Ready to book? (a selection for each offergroup) */}
            { selectionByOfferGroup.size === offerGroups.size &&
            selectionByOfferGroup.every( sel => sel.size > 0) &&
            <footer>
                <button className="btn btn-primary min-width-140"
                    onClick={startBooking}>Book</button>
            </footer>
            }
        </div>
      </div>
    </div>
  }
}


export default AccommodationOffersResponse



// WEBPACK FOOTER //
// ./src/ndc/offer/AccommodationOffersResponse.js